export default "__VITE_ASSET__Cgf52OUk__"